import styled from 'styled-components';
import { IThemeProvider } from '../../../../styles/theme';

export const InformationTextCont = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  width: 432px;
  ${({ theme }: IThemeProvider) => `
    height: ${theme.layout.spacing.deka};
  `}
`;
